import { css } from '@emotion/core';

// styling for react spinners
export const spinnerStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
`;

export const sizeUnit = 'px';
export const size = 50;
export const color = '#3cd1bf';
export const docColor = '#2a2a36';
